import { render, staticRenderFns } from "./SwiperNews.vue?vue&type=template&id=2d0828f0&"
import script from "./SwiperNews.vue?vue&type=script&lang=js&"
export * from "./SwiperNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports